import { useCallback } from "react";

const useRoomTypeOptions = ({
    roomNumbersByType,
    setRoomNumbersByType,
    setRoomOfferByType,
    setComplementryByType,
    setRoomTypeInfoByType,
    roomTypeInfoByType,
    roomOfferByType,
    values,
    setChildrenMinAge,
    setChildrenMaxAge = () => { },
    getCombinedRoomInfo = () => { },

}) => {
    const ensureTypeOptions = useCallback(
        async (roomId, room, index) => {
            const roomNo = room?.room_no;
            const { checkin_date, checkout_date } = values;

            if (!roomId || !checkin_date || !checkout_date) {
                return null;
            }


            const roomKey = `${roomId}_${index}`;

            try {
                // Already loaded — return cached data
                if (roomTypeInfoByType[roomKey]) {
                    return {
                        roomTypeInfo: roomTypeInfoByType[roomKey],
                        offerValue: roomOfferByType[roomKey] ?? 0,
                    };
                }

                const res = await getCombinedRoomInfo(roomId, { checkin_date, checkout_date });

                // Pre-booked room
                if (room?.book_details_id) {
                    const apiInfo = res?.room_type_info || {};

                    const roomTypeInfo = {
                        room_id: room.room_id,
                        room_no: room.room_no,
                        room_type: room.room_type || apiInfo.room_type || "",
                        capacity: Number(room.capacity || apiInfo.capacity) || 0,
                        exbed_capability: Number(room.exbed_capability || apiInfo.exbed_capability) || 0,
                        exbed_capability_limit: Number(room.exbed_capability_limit || apiInfo.exbed_capability_limit) || 0,
                        child_limit: Number(room.child_limit || apiInfo.child_limit) || 0,
                        extra_bed_charge: Number(room.extra_bed_charge || apiInfo.extra_bed_charge) || 0,
                        extra_person_charge: Number(room.extra_person_charge || apiInfo.extra_person_charge) || 0,
                        extra_child_charge: Number(room.extra_child_charge || apiInfo.extra_child_charge) || 0,
                        room_rate: Number(room.room_rate || apiInfo.room_rate) || 0,
                        children_min_age: Number(room.children_min_age || apiInfo.children_min_age) || 0,
                        children_max_age: Number(room.children_max_age || apiInfo.children_max_age) || 0
                    };

                    const complementary = [
                        {
                            complementary_id: room.complementary_id,
                            complementary_price: room.complementary_price,
                            complementary_name: room.complementary_name,
                            complementary_price_type: room.complementary_price_type
                        },
                        ...(res.complementary || []).filter(
                            item => item.complementary_id !== room.complementary_id
                        ),
                    ];

                    setRoomNumbersByType(prev => ({ ...prev, [roomId]: res.rooms || [] }));

                    if (roomId && roomNo) {
                        setRoomOfferByType(prev => ({ ...prev, [roomKey]: room.room_offer || 0 }));
                        setRoomTypeInfoByType(prev => ({ ...prev, [roomKey]: roomTypeInfo }));
                        if (room.complementary_id && room.complementary_price) {
                            setComplementryByType(prev => ({ ...prev, [roomKey]: complementary || [] }));
                        } else {
                            setComplementryByType(prev => ({ ...prev, [roomKey]: res.complementary || [] }));
                        }
                    }

                    if (setChildrenMinAge) {
                        setChildrenMinAge(roomTypeInfo.children_min_age || 6);
                    } else if (setChildrenMaxAge) {
                        setChildrenMaxAge(roomTypeInfo.children_max_age || 12);
                    }

                    return {
                        roomTypeInfo,
                        offerValue: room.room_offer || 0,
                    };
                }


                setRoomNumbersByType(prev => ({ ...prev, [roomId]: res.rooms || [] }));
                if (roomId && roomNo) {
                    setComplementryByType(prev => ({ ...prev, [roomKey]: res.complementary || [] }));
                    setRoomOfferByType(prev => ({ ...prev, [roomKey]: res.offerValue || 0 }));
                    setRoomTypeInfoByType(prev => ({ ...prev, [roomKey]: res.room_type_info || {} }));
                    setChildrenMinAge(res.room_type_info.children_min_age || 6);
                    setChildrenMaxAge(res.room_type_info.children_max_age || 12);
                }

                return {
                    roomTypeInfo: res.room_type_info || {},
                    offerValue: res.offerValue || 0,
                };

            } catch (error) {
                console.error(`Error loading room options for ${roomKey}:`, error);
                return null;
            }
        },
        [
            roomNumbersByType,
            setRoomNumbersByType,
            setRoomOfferByType,
            setComplementryByType,
            setRoomTypeInfoByType,
            values.checkin_date,
            values.checkout_date
        ]
    );

    return { ensureTypeOptions };
};

export default useRoomTypeOptions;